import { scrollTo } from "@/lib/scroll";

const NAV = [
  { label: "Approach", hash: "#approach" },
  { label: "Services", hash: "#services" },
  { label: "Sectors", hash: "#sectors" },
  { label: "Contact", hash: "#contact" },
];

const OFFICES = ["London, United Kingdom"];

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="relative overflow-hidden bg-obsidian text-zinc-400">
      <div
        aria-hidden
        className="pointer-events-none select-none whitespace-nowrap font-serif text-[22vw] font-bold leading-none text-outline-light absolute -bottom-[6vw] left-1/2 -translate-x-1/2"
      >
        CONNECT
      </div>

      <div className="relative mx-auto max-w-7xl px-4 pb-40 pt-20 sm:px-6 lg:px-8 lg:pt-28">
        <div className="grid grid-cols-1 gap-12 md:grid-cols-3">
          <div>
            <div className="flex items-center gap-3">
              <span className="relative flex h-8 w-8 items-center justify-center">
                <span className="absolute left-0 h-5 w-5 rounded-full border-2 border-gold/70" />
                <span className="absolute right-0 h-5 w-5 rounded-full border-2 border-gold" />
              </span>
              <span className="font-serif text-lg font-semibold tracking-[0.18em] text-alabaster">
                CONNECT
              </span>
            </div>
            <p className="mt-6 max-w-xs text-sm leading-relaxed">
              Independent retail &amp; HoReCa advisory.
            </p>
          </div>

          <div>
            <span className="font-mono text-[10px] uppercase tracking-[0.3em] text-zinc-500">
              Navigate
            </span>
            <ul className="mt-5 space-y-3">
              {NAV.map((n) => (
                <li key={n.hash}>
                  <button
                    data-testid={`footer-link-${n.label.toLowerCase()}`}
                    onClick={() => scrollTo(n.hash)}
                    className="text-sm transition-colors duration-300 hover:text-gold"
                  >
                    {n.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <span className="font-mono text-[10px] uppercase tracking-[0.3em] text-zinc-500">
              Offices
            </span>
            <ul className="mt-5 space-y-3">
              {OFFICES.map((o) => (
                <li key={o} className="text-sm">
                  {o}
                </li>
              ))}
            </ul>
            <p className="mt-8 font-mono text-[10px] uppercase leading-relaxed tracking-[0.22em] text-zinc-600">
              All engagements covered by strict confidentiality protocol
            </p>
          </div>
        </div>
      </div>

      <div className="relative border-t border-white/10">
        <div className="mx-auto flex max-w-7xl flex-col items-center justify-between gap-3 px-4 py-6 font-mono text-[10px] uppercase tracking-[0.22em] text-zinc-600 sm:flex-row sm:px-6 lg:px-8">
          <span>© 2026 Connect</span>
          <span>Food · Non-Food · Supermarkets · HoReCa</span>
        </div>
      </div>
    </footer>
  );
}
